import { TWorkerInformationPayload } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const validateWorkerShareableLinkToken = (axios: IAxiosInstance) => {
  return async (body: { accessToken: string }) => {
    const response = await axios.noRetry.post<{
      data: TWorkerInformationPayload;
    }>("/api/validateWorkerShareableLinkToken", body);
    return response.data.data;
  };
};
